module.exports = __webpack_public_path__ + "img/mobile-rental-assets-04.e031e540.png";